import BigNumber from "bignumber.js";
function parseAmount(amount, coinDecimals) {
  try {
    return BigInt(new BigNumber(amount).shiftedBy(coinDecimals).integerValue().toString());
  } catch (e) {
    return BigInt(0);
  }
}
function safeParseAmount(amount, coinDecimals) {
  try {
    return BigInt(new BigNumber(amount).shiftedBy(coinDecimals).integerValue().toString());
  } catch (e) {
    return null;
  }
}
export {
  parseAmount,
  safeParseAmount
};
//# sourceMappingURL=parse.js.map
